module.exports = __webpack_public_path__ + "assets-cabinet/img/checkbox-toggle.fee062c7.svg";